module.exports = __webpack_public_path__ + "static/khachanov-red-462597f0c515f23f7d60c645c5932e24.png";